// extracted by mini-css-extract-plugin
export default {"base-layout":"#f2f2f2","layout-with-navbar":"#fff","dashboard-layout":"#3d4a5e"};